module.exports = __webpack_public_path__ + "static/img/02.f520c1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/eggenberger/02.jpg
// module id = 362
// module chunks = 1